/**
 * Чему в отчётах можно верить.
 *
 * Две разные беды, и путать их нельзя.
 *
 * **Не посчитано.** Traccar на длинных промежутках возвращает нули в
 * максимальной скорости и моточасах, даже когда машина явно ездила.
 * Воспроизведено на стенде: у одной и той же машины с одним и тем же концом
 * периода меняется только начало окна — на сутках значения приходят, на двух
 * сутках уже нули. Печатать такой ноль как измерение нельзя: «макс. 0 км/ч» у
 * машины, проехавшей четыре тысячи километров, читается не как осторожность, а
 * как поломка — и обесценивает весь отчёт.
 *
 * **Сбился счётчик.** Отрицательный пробег означает, что одометр машины
 * начался заново — так бывает при замене трекера. Тогда врёт не только пробег,
 * но и всё, что из него считается: средняя скорость выходит отрицательной, а
 * «средняя −336 км/ч» — это уже не осторожность и не поломка, это бессмыслица.
 *
 * Что при этом мерилось независимо от одометра — максимальная скорость по
 * точкам, моточасы по счётчику двигателя — сбоем пробега не портится, и
 * прятать его нет причин.
 *
 * Сам пробег показывается всегда, даже отрицательный: это единственный признак
 * того, что с данными машины что-то произошло, и он важнее аккуратности.
 */

export type Measured = {
  distance: number
  averageSpeed?: number
  maxSpeed?: number
  engineHours?: number
}

export type MeasuredField = 'distance' | 'averageSpeed' | 'maxSpeed' | 'engineHours'

export function believable(row: Measured, field: MeasuredField): boolean {
  if (field === 'distance') return true

  const moved = row.distance !== 0

  if (field === 'averageSpeed') {
    // Считается из пробега: сбился он — бессмысленна и она.
    if (row.distance < 0) return false
    // Средняя выше максимальной физически невозможна. Найдено на стенде:
    // Traccar отдал среднюю 106 км/ч при максимальной 50 — значит считал их по
    // разным данным, и средней верить нельзя.
    if (
      typeof row.maxSpeed === 'number' &&
      row.maxSpeed > 0 &&
      typeof row.averageSpeed === 'number' &&
      row.averageSpeed > row.maxSpeed
    ) {
      return false
    }
    return moved ? row.averageSpeed !== 0 : true
  }

  // Максимальная скорость меряется по точкам, моточасы — по счётчику
  // двигателя. От одометра оба не зависят, и портит их только то, что величину
  // не посчитали вовсе.
  return moved ? row[field] !== 0 : true
}
